export interface GameAssetEntry {
  key: 'background' | 'player' | 'prey' | 'predator';
  src: string;
}
export const GAME_ASSETS: readonly GameAssetEntry[] = [
  { key: 'background', src: '/assets/background.jpg' },
  { key: 'player', src: '/assets/player.svg' },
  { key: 'prey', src: '/assets/fish_prey.svg' },
  { key: 'predator', src: '/assets/fish_predator.svg' },
];